<template>
  <div class="weight-balance-container">
    <!-- x: {{ xFrom }} - {{ xTo }}
    <br>
    y: {{ yFrom }} - {{ yTo }} -->
    <!-- {{ lines }} -->
    <HiloChart
      :xFrom="xFrom"
      :xTo="xTo"
      :yFrom="yFrom"
      :yTo="yTo"
      :datasets="[...datasets, ...lines]"
    />
    <div>
      <button class="primary" @click="$emit('next')">Next</button>
    </div>
  </div>
</template>

<script>
import HiloChart from "./HiloChart.vue";
export default {
  components: {
    HiloChart,
  },
  props: {
    weightBalance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    twLw() {
      const data = this.datasets.map(dataset => dataset.data);
      const x = data.map(x => x[0].x);
      const y = data.map(y => y[0].y);

      return { x, y };
    },
    xFrom() {
      return (Math.floor(Math.min(...this.twLw.x) / 5) * 5) - 4;
    },
    xTo() {
      return (Math.ceil(Math.max(...this.twLw.x) / 5) * 5) + 5;
    },
    yFrom() {
      return (Math.floor(Math.min(...this.twLw.y) / 100) * 100) - 300;
    },
    yTo() {
      return (Math.ceil(Math.max(...this.twLw.y) / 100) * 100) + 300;
    },
    details() {
      return this.weightBalance;
    },
    datasets() {
      return [
        {
          label: 'TW',
          data: [{ x: this.details.tw.x, y: this.details.tw.y }],
          borderColor: '#01AA34',
          backgroundColor: '#01AA34',
          pointRadius: 6,
          pointHoverRadius: 8,
          showLine: false,
        },
        {
          label: 'LW',
          data: [{ x: this.details.lw.x, y: this.details.lw.y }],
          borderColor: '#01AA34',
          backgroundColor: '#01AA34',
          pointRadius: 6,
          pointHoverRadius: 8,
          showLine: false,
        },
      ];
    },
    lines() {
      return [
        {
          label: '',
          data: [
            { x: (this.xFrom + 9) - .03, y: this.yFrom },
            { x: (this.xFrom + 9) - .03, y: this.yTo - 5 },
          ],
          borderColor: 'black',
          backgroundColor: 'black',
          borderWidth: 2,
          pointRadius: 0,
          showLine: true,
          fill: false,
        },
        {
          label: '',
          data: [
            { x: this.xFrom + .03, y: this.yFrom },
            { x: this.xFrom + .03, y: this.yFrom + 600 },
          ],
          borderColor: 'black',
          backgroundColor: 'black',
          borderWidth: 2,
          pointRadius: 0,
          showLine: true,
          fill: false,
        },
        {
          label: '',
          data: [
            { x: this.xFrom + .03, y: this.yFrom + 600 },
            { x: this.xFrom + 3, y: this.yTo - 5 },
          ],
          borderColor: 'black',
          backgroundColor: 'black',
          borderWidth: 2,
          pointRadius: 0,
          showLine: true,
          fill: false,
        },
        {
          label: '',
          data: [
            { x: this.xFrom + 3, y: this.yTo - 5 },
            { x: this.xTo + 3, y: this.yTo - 5 },
          ],
          borderColor: 'black',
          backgroundColor: 'black',
          borderWidth: 2,
          pointRadius: 0,
          showLine: true,
          fill: false,
        },
      ]
    }
  },
};
</script>
<style></style>
